import Vue from 'vue'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

const COOKIE_VERSAO = 'versao_app'
const COOKIE_FORCADA = 'versao_app_forcada'
const VERSOES_VALIDAS = ['monolito', 'beta', 'hml']
const EXPIRACAO_VERSAO = '30d'
const EXPIRACAO_FORCADA = '7d'

let versaoPendente = null

// Cookie versao_app_forcada guarda 'versao|base', onde base é o valor que o
// banco tinha na hora da troca manual — se o banco mudar depois (equipe agiu
// via Areadev), o override é descartado e o banco volta a valer.
const pegaOverride = () => {
    const bruto = Vue.$cookies.get(COOKIE_FORCADA)
    if (!bruto) {
        return null
    }
    const partes = String(bruto).split('|')
    if (
        partes.length !== 2
        ||
        !VERSOES_VALIDAS.includes(partes[0])
        ||
        !VERSOES_VALIDAS.includes(partes[1])
    ) {
        Vue.$cookies.remove(COOKIE_FORCADA)
        return null
    }
    return {
        versao: partes[0],
        base: partes[1]
    }
}

export const aplicaVersaoAppDaUrl = () => {
    const url = new URL(window.location.href)
    const versao = url.searchParams.get(COOKIE_VERSAO)
    if (versao === null) {
        return false
    }
    url.searchParams.delete(COOKIE_VERSAO)
    window.history.replaceState(null, '', url.pathname + url.search + url.hash)
    if (versao === 'auto') {
        Vue.$cookies.remove(COOKIE_FORCADA)
        Vue.$cookies.remove(COOKIE_VERSAO)
        window.location.reload()
        return true
    }
    if (!VERSOES_VALIDAS.includes(versao)) {
        return false
    }
    const override = pegaOverride()
    const base = (override && override.base)
        || Vue.$cookies.get(COOKIE_VERSAO)
        || 'monolito'
    Vue.$cookies.set(COOKIE_FORCADA, versao + '|' + base, EXPIRACAO_FORCADA)
    Vue.$cookies.set(COOKIE_VERSAO, versao, EXPIRACAO_VERSAO)
    window.location.reload()
    return true
}

export const processaVersaoAppResposta = (headers) => {
    const versaoBanco = headers && headers['x-versao-app']
    if (!versaoBanco || !VERSOES_VALIDAS.includes(versaoBanco)) {
        return
    }
    const override = pegaOverride()
    const cookieAtual = Vue.$cookies.get(COOKIE_VERSAO)
    if (override) {
        if (versaoBanco === override.base) {
            if (cookieAtual !== override.versao) {
                versaoPendente = override.versao
            }
            return
        }
        Vue.$cookies.remove(COOKIE_FORCADA)
    }
    if (versaoBanco !== cookieAtual) {
        versaoPendente = versaoBanco
    }
}

// A troca só é aplicada na navegação de rota (destinoHref já resolvido pelo
// router), nunca no meio de uma tela — evita perder formulário em edição.
export const aplicaVersaoAppPendente = (destinoHref) => {
    if (!versaoPendente) {
        return false
    }
    Vue.$cookies.set(COOKIE_VERSAO, versaoPendente, EXPIRACAO_VERSAO)
    versaoPendente = null
    window.location.href = destinoHref
    return true
}
